import {Module, NextModule} from '@backstage-components/base';
import React from 'react';
import {
  RichTextComponent,
  RichTextComponentDefinition,
} from './RichTextComponent';
import {ComponentDefinition} from './RichTextDefinition';

type Kind = RichTextComponentDefinition['component'];

type Props = RichTextComponentDefinition['props'];

export const RichTextModule: Module<Kind, Props> = {
  isContent(value): value is RichTextComponentDefinition {
    return (
      value.component === ComponentDefinition.reactName &&
      value.cid === ComponentDefinition.id
    );
  },
  isLayout(value): value is RichTextComponentDefinition {
    return false;
  },
  tryRender(definition) {
    if (RichTextModule.isContent(definition)) {
      return React.createElement(RichTextComponent, definition);
    } else {
      return NextModule;
    }
  },
};
